<template>
  <section class="sendBack">
	<header-com isTransparent/>
 
	<!---------已退回----------->
	<div class="tips"   >
	   <h3 class=" f32 bold" v-if="isSendBack">平台待收货</h3>
	</div>
	<!--&lt;!&ndash;-&#45;&#45;&#45;&#45;&#45;&#45;未退回&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
	<!--<div class="tips" v-else>-->
		<!--<div class="fromPay" v-if="from ==='1'">不着急用包的情况下，可在订单里先退回在的包包，再预约新包。</div>-->
		<!--<div class="fromOrder" v-else>-->
		  <!--<i>可提前预约换背新包，享受不间断背包体验。</i><span class="r">换背新包</span>-->
		<!--</div>-->
	<!--</div>-->
 
	<!---------已退回----------->
	<div class="addressWrap f28"   v-if="isSendBack">
	  <p class="bold">你的包包平台等待接收中</p>
	  <p>{{returnOrderDetail.deliveryTime || returnOrderDetail.orderReturnApply.createTime}}</p>
	</div>
	<!---------未退回------------>
	<div class="addressWrap f28" v-else>
	  <p><strong>{{comAddObj.name}}</strong><strong>{{comAddObj.mobile}}</strong></p>
	  <p>{{comAddObj.fullAddress}}</p>
	</div>
	
	<section class="contentWrap">
	  <h2>待退回，陈真全额回购 <span class="subTitle"  @click="$showStandardPopup">了解详情</span></h2>
	  <pro-info-com class="proInfoCom" :item="orderItem">
		<!---------已退回----------->
		<div  v-if="isSendBack">
		  <p class="f24 price"><span class="bold">退还金额</span><span> ¥</span><span class="f48 bold">{{orderItem.productPrice}}</span></p>
		</div>
		<!---------未退回------------>
		<div v-else>
		  <p class="f24 price"><span class="bold">回购价</span><span> ¥</span><span class="f48 bold">{{orderItem.productPrice}}</span></p>
		  <!--<h6 class="f22">你正在使用季度换背保障服务，享受全额回购。</h6>-->
		</div>
	  </pro-info-com>
	  
	  <!---------已退回----------->
	  <div class="orderInfo" v-if="isSendBack">
		<h2>订单信息</h2>
		<ul class="f28 grey9">
		  <li>快递单号：{{expressObj.expressSn}}</li>
		  <li>快递公司：{{expressObj.expressType }}</li>
		  <!--<li>退款方式：原路返回</li>-->
		</ul>
	  </div>
	  <!---------未退回------------>
	  <!--快递相关-->
	  <ul v-else class="f28 expressWrap">
		<li @click="isShowExpressPopup = true">
			<h3>承运快递</h3><span >{{expressObj.expressType || '请选择快递'}}</span>
		</li>
		<li>
		  <h3>快递单号</h3><input v-model="expressObj.expressSn"
							  @blur="inputBlur"
							  class="t_right"
							  type="text" placeholder="请输入快递单号">
		</li>
	  </ul>
	  
	</section>
 
	<!--快递弹窗-->
	<van-popup v-model="isShowExpressPopup" position="bottom">
	  <van-picker show-toolbar
				  :columns="expressList"
				  value-key="fullName"
				  @confirm="confirmExpress"
				  @cancel="isShowExpressPopup = false"></van-picker>
	</van-popup>
 
 
 
	<div  v-if="isSendBack" class="g-fixed-bottom t_right">
	  <button class="primary" @click="toReturnOrder">查看退回订单</button>
	</div>
	<!---------未退回------------>
	<div v-else>
	  <bottom-tip/>
	  <div class="g-fixed-bottom t_right">
		<button class="primary" @click="submit">确认 </button>
	  </div>
	</div>
	
	
  </section>
</template>

<script>
  import { mapState } from 'vuex'
  import orderApi from '@api/order'
  import publicObj from '@utils/public'
  export default {
    name: "sendBack",
    components: {},
    data() {
      return {
        isSendBack:false,
		sendBackTime:'',
		isShowExpressPopup:false,
        expressObj:{
          expressTypeId:'',
          expressType:'',
          expressSn:''
		},
        expressList:[],
        returnOrderDetail:{
          orderItem:{},
          orderReturnApply:{}
		},
		orderDetail:{}
	  }
    },
    watch: {},
    computed: {
      ...mapState({
        comAddObj:'comAddObj'
	  }),
      from() {
        // from 1 下单成功后进入退回；2 从退回订单进入退回；3 从购买订单进入退回
        return this.$route.query.from || '1'
      },
      id(){
        return this.$route.query.id
	  },
      orderCode(){
        return this.$route.query.orderCode
      },
      orderItem(){
        return this.returnOrderDetail.orderItem || this.returnOrderDetail.orderItemDTO
      }
	},
    created() {
      this.getExpress();
     
      if(this.id){
        //1 下单成功后进入退回；2 从退回订单进入退回
        //获取退回订单详情
        this.getOrderReturnDetail()
	  }else {
        // 3 从购买订单进入退回
        // 获取订单详情
        this.getOrderDetail()
      }
    },
    mounted() {
    },
    methods: {
      inputBlur(){
        publicObj.IPhoneXHack()
      },
      //获取退回订单详情
      getOrderReturnDetail(){
        orderApi.getOrderReturnDetail(this.id).then(res =>{
          this.returnOrderDetail = res;
          if(res.expressSn){
            this.isSendBack = true;
            this.expressObj = {
              expressTypeId:res.expressTypeId,
              expressType:res.expressType,
              expressSn:res.expressSn,
            }
		  }
        })
      },
	  // 获取订单详情
	  getOrderDetail(){
        orderApi.getOrderDetail({
          orderCode:this.orderCode
		}).then(res=>{
          this.returnOrderDetail = res;
          if(res.orderReturnApply){
            this.isSendBack = true
			this.expressObj = {
              expressTypeId:res.orderReturnApply.expressTypeId,
              expressType:res.orderReturnApply.expressType,
              expressSn:res.orderReturnApply.expressSn,
			}
		  }
        });
	  },
      //获取快递列表
      getExpress(){
        orderApi.getExpress().then(res=>{
		  this.expressList = res
		})
	  },
	  //确认快递
      confirmExpress(data){
        console.log(data);
		this.expressObj = {
          expressType:data.fullName,
          expressTypeId:data.typeId,
          expressSn:''
		};
        this.isShowExpressPopup = false
	  },
	  toReturnOrder(){
        if(this.from === '2') {
          //从退回订单进入退回
          this.$router.back()
        }else {
          this.$router.push({name:'returnOrder'})
		}
	  },
	  //确认退回
      submit(){
        if(!this.expressObj.expressType){
		  this.$toast('请选择快递');
		  return
        }

        if(!this.expressObj.expressSn){
          this.$toast('快递单号不能为空');
          return
        }
        if(this.from !== '3'){
          //1 下单成功后进入退回；2 从退回订单进入退回
		  // 是更新退回订单信息
          orderApi.updateExpress({
            id:this.returnOrderDetail.id,
            ...this.expressObj
          }).then(res => {
            this.$toast('退回成功！');
            this.getOrderReturnDetail()
            // this.isSendBack = true
          })
		}else {
          // 3 从购买订单进入退回
		  //  是创建退回订单
          orderApi.createReturnOrder({
            orderCode:this.returnOrderDetail.orderCode,
            orderItemId:this.orderItem.id,
            ...this.expressObj
          }).then(res => {
            this.$toast('退回成功！');
            this.getOrderDetail()
            // this.isSendBack = true
          })
		}
   
   
	  }
	}

  }
</script>

<style lang="scss" scoped>
.sendBack{
  padding:  0 0 180px;
  /*顶部提示*/
  .tips{
	height: 68px;
	padding: 24px 60px 24px 100px;
	background: $primary-color;
	color: $white-color;
	letter-spacing: -.5px;
	h3{
	  line-height: 68px;
	  /*padding-left: 110px;*/
	  /*background: url("/images/order/send_back_icon.png") no-repeat 24px center;*/
	  /*background-size: 52px;*/
	}
	.fromPay{
	  line-height: 34px;
	}
	.fromOrder{
	  padding: 14px 0;
	  line-height: 40px;
	  span{
		width:126px;
		text-align: center;
		height:42px;
		border-radius:21px;
		box-sizing: border-box;
		border:2px solid $white-color;
	  }
	}
  }
  
  /*地址区*/
  .addressWrap{
	border-bottom: $dashed-border;
	padding: 50px 40px;
	margin-bottom: 60px;
	line-height: 40px;
	strong{margin-right: 30px}
	p:first-of-type{
	  margin-bottom: 16px;
	}
  }
  
  /**/
  .contentWrap{
	padding: 0 40px;
	h2{
	  margin-bottom: 50px;
	  line-height: 36px;
	  font-weight: bold;
	  font-size: 32px;
	  span{
		padding-right: 28px;
		background: url("/images/base/arrow_right_grey.png") no-repeat right center;
		background-size: 10px;
		font-weight: normal;
	  }
	}
	.price{
	  line-height: 66px;
	  /*margin-bottom: 30px;*/
	}
	h6{
	  color: $brand-color;
	  line-height: 32px;
	}
	.proInfoCom{
	  margin-bottom: 80px;
	}
	/*快递相关*/
	.expressWrap{
	  >li{
		display: flex;
		justify-content: space-between;
		line-height: 32px;
		margin-bottom: 48px;
		span{
		  padding-right: 30px;
		  background: url("/images/base/arrow_right.png") no-repeat right ;
		  background-size: 10px;
		}
		h3{
		  font-size: 28px;
		  font-weight: bold;
		}
	  }
	  
	}
	
	.orderInfo{
	  li{
		margin-bottom: 20px;
	  }
	}
  }
  
}
</style>
